function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/UserGroupApi"; // ユーザーグループ絞り込みモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 表示
   */

  Mode[Mode["Open"] = 1] = "Open";
})(Mode || (Mode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);

    switch (props.mode) {
      case Mode.Open:
        _this.state = {
          SelectedGroupIdList: _this.props.selectedGroupIdList,
          UserGroupNarrowdownList: []
        };
        Api.QueryUserGroupNarrowdownList(function (data) {
          _this.setState({
            UserGroupNarrowdownList: data
          });
        });
        break;

      default:
        throw Error();
    }

    return _this;
  }
  /**
   * 選択の変更時
   */


  _createClass(MainComponent, [{
    key: "updateSelected",
    value: function updateSelected(model, e) {
      var _this2 = this;

      var selectedGroupIdList = this.state.SelectedGroupIdList.filter(function (x) {
        return x != model.Id;
      });

      if (e.target.checked) {
        selectedGroupIdList.push(model.Id);
      }

      this.setState({
        SelectedGroupIdList: selectedGroupIdList
      });
      var groupNameList = [];
      var userList = [];
      selectedGroupIdList.map(function (x) {
        var targets = _this2.state.UserGroupNarrowdownList.filter(function (m) {
          return m.Id == x;
        });

        if (targets.length > 0) {
          groupNameList.push(targets[0].Name);
          userList = userList.concat(targets[0].UserList);
        }
      });
      var userIdList = [];
      var userKeyList = [];
      userList.map(function (x) {
        userIdList.push(x.Id);
        userKeyList.push(x.Key);
      });
      this.props.onChange(groupNameList.join(","), selectedGroupIdList, Array.from(new Set(userIdList)), Array.from(new Set(userKeyList)));
    }
    /**
     * モーダルマウスダウン
     */

  }, {
    key: "onModal",
    value: function onModal(e) {
      e.stopPropagation();
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "UserGroupNarrowdownModal",
        onClick: this.onModal.bind(this),
        style: {
          top: this.props.top,
          left: this.props.left
        }
      }, /*#__PURE__*/React.createElement("ul", {
        className: "col-12 list-group list-group-flush"
      }, this.state.UserGroupNarrowdownList.map(function (x) {
        return /*#__PURE__*/React.createElement("li", {
          className: "list-group-item",
          key: x.Id
        }, /*#__PURE__*/React.createElement("div", {
          className: "checkbox icheck-asbestos"
        }, /*#__PURE__*/React.createElement("input", {
          type: "checkbox",
          id: "GroupId-" + x.Id,
          name: "GroupId-" + x.Id,
          onChange: _this3.updateSelected.bind(_this3, x),
          checked: _this3.state.SelectedGroupIdList.some(function (m) {
            return m == x.Id;
          })
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: "GroupId-" + x.Id
        }, x.Name)));
      })));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };